'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.pagination = pagination;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRange(start, end) {
  return Array(end - start + 1).fill(0).map(function (v, i) {
    return i + start;
  });
}

function pagination(current, length) {
  if (length <= 9) {
    return getRange(0, length - 1);
  }

  if (current <= 3) {
    return [0, 1, 2, 3, 4, 5, 6, '...', length - 1];
  }

  if (current >= length - 1 - 5) {
    return [0, '...', length - 7, length - 6, length - 5, length - 4, length - 3, length - 2, length - 1];
  }

  return [0, '...'].concat((0, _toConsumableArray3.default)(getRange(current - 2, current + 2)), ['...', length - 1]);
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/pagination.js
// module id = 2306
// module chunks = 0